/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch } from "react-redux";
import { changeToast, setToast } from "@potoo-modules/functions";
import { ToastType } from "@potoo-modules/classes";

type ToastProps = {
  type: ToastType; //type: success, info, caution, danger, no_icon
  toast_text: string;
  btn_label?: string;
  onBtnClick?: () => void;
  isShown: boolean;
};

// 피그마: https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=329-8616&t=3lunUvpzgaQBTI5S-4
const Toast = (props: ToastProps) => {
  const { type, toast_text, btn_label, onBtnClick, isShown } = props;

  const isDesktop = useMediaQuery({
    query: "(min-width:768px)",
  });
  const isCloseBtn = btn_label === "닫기" || btn_label === "Close";
  const isChannelTalkBtn = btn_label?.includes("Channel Talk") ||
    btn_label?.includes("채널톡") ||
    btn_label === "unknownErrorBtn";
  // 버튼 스타일 결정

  var iconClass = "";
  switch (type) {
    case ToastType.success:
      iconClass = "icon-icon-check-filled-circled green-500";
      break;
    case ToastType.info:
      iconClass = "icon-icon-caution-filled-circled blue-600";
      break;
    case ToastType.caution:
      iconClass = "icon-icon-caution-filled-circled orange-500";
      break;
    case ToastType.danger:
      iconClass = "icon-icon-x-filled-circled red-500";
      break;
  }

  const [isToastAnimation, setIsToastAnimation] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    //맨 처음 render시 실행됨
    if (isShown === true) {
      setIsToastAnimation(true);
    }
    //4초 뒤에 닫는 걸 여기다가 넣자
    setTimeout(() => {
      setIsToastAnimation(false);
      setTimeout(function () {
        dispatch(
          setToast({
            isShown: false,
            toast_type: ToastType.no_icon,
            toast_text: "",
            btn_label: "",
            onBtnClick: () => { },
          })
        );
        // dispatch(changeToast(false));
      }, 300); //0.3s
    }, 4000);
  }, []);

  if (isDesktop)
    return (
      <div className={`toast ${isToastAnimation === true ? "show-toast " : " "}`}>
        {/* icon */}
        {iconClass !== "" && (
          <i
            className={iconClass}
            style={{
              fontSize: 24,
            }}
          />
        )}

        <span
          className="body1-700 gray-800"
          style={{
            padding: "2px 0",
            textAlign: "start",
            width: "100vw",
            margin: "0",
            whiteSpace: "pre-line",
          }}
        >
          {toast_text}
        </span>

        {/* button */}
        {btn_label && (
          <div
            onClick={() => {
              if (isCloseBtn) {
                //닫기일 때는 닫기
                setIsToastAnimation(false);
                setTimeout(function () {
                  dispatch(changeToast(false));
                }, 300); //0.3s
              } else {
                if (onBtnClick) onBtnClick();
              }
            }}
            className="body1-500 gray-400 click btn-label"
            style={{ whiteSpace: "nowrap" }}
          >
            {isCloseBtn ? <i className="icon-icon-x gray-400 font-size-16" /> : btn_label}
          </div>
        )}
      </div>
    );

  //mobile
  return (
    <div className={`toast ${isToastAnimation === true ? "show-toast " : " "}`}>
      {/* icon */}
      {iconClass !== "" && (
        <i
          className={iconClass}
          style={{
            fontSize: 18,
          }}
        />
      )}

      <span
        className="body2-700 gray-800"
        style={{
          padding: "1px 0",
          textAlign: "start",
          width: "100vw",
          margin: "0",
          whiteSpace: "pre-line",
        }}
      >
        {toast_text}
      </span>

      {/* button */}
      {btn_label && (
        <div
          onClick={() => {
            if (btn_label === "닫기") {
              //닫기일 때는 닫기
              setIsToastAnimation(false);
              setTimeout(function () {
                dispatch(changeToast(false));
              }, 300); //0.3s
            } else {
              if (onBtnClick) onBtnClick();
            }
          }}
          className="body2-500 gray-5 click"
          style={{ whiteSpace: "nowrap" }}
        >
          {isCloseBtn ? <i className="icon-icon-x gray-400 font-size-16" /> : btn_label}
        </div>
      )}
    </div>
  );
};

export { Toast };
